import React from "react";
import BankPaymentInfo from "./BankPaymentInfo";
import PanInfo from "./PanInfo";
import EmployeePFInfo from "./EmployeePFInfo";
import EmployeeInsurance from "./EmployeeInsurance";
import ProfessionalTaxInfo from "./ProfessionalTaxInfo";

const BankInfo = ({ employee }) => {
  return (
    <div>
      <BankPaymentInfo employee={employee} />
      <PanInfo employee={employee} />
      <EmployeePFInfo employee={employee} />
      <EmployeeInsurance employee={employee} />
      <ProfessionalTaxInfo employee={employee} />
    </div>
  );
};

export default BankInfo;
